import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { getSeverityColor } from '../../utils/palette.utils';
import { capitalizeFirstLetter } from '../../utils/utils';
import { CONSTANTS } from '../../constants/constants';

export const getSeverityLabel = input => {
  if (input == null) return '';
  const text = String(input);

  switch (text) {
    case CONSTANTS.SERVER_SEVERITIES.SEVERITY_NONE:
      return CONSTANTS.SEVERITIES.NONE;
    case CONSTANTS.SERVER_SEVERITIES.SEVERITY_LOW:
      return CONSTANTS.SEVERITIES.LOW;
    case CONSTANTS.SERVER_SEVERITIES.SEVERITY_MEDIUM:
      return CONSTANTS.SEVERITIES.MEDIUM;
    case CONSTANTS.SERVER_SEVERITIES.SEVERITY_HIGH:
      return CONSTANTS.SEVERITIES.HIGH;
    case CONSTANTS.SERVER_SEVERITIES.SEVERITY_CRITICAL:
      return CONSTANTS.SEVERITIES.CRITICAL;
    default:
      return text;
  }
};

function NRSeverityLabel({ severity, cvssScore }) {
  const theme = useTheme();

  const score = Number(cvssScore);
  const formattedScore = cvssScore != null && !isNaN(score) ? score.toFixed(1) : '';
  const severityLabel = capitalizeFirstLetter(getSeverityLabel(severity));
  const displayText = formattedScore ? `${formattedScore} ${severityLabel}` : severityLabel;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        gap: 1
      }}
    >
      <Box
        sx={{
          width: 4,
          height: 16,
          borderRadius: theme.shape.borderRadius,
          backgroundColor: getSeverityColor(severity, theme),
          flexShrink: 0
        }}
      />
      <Typography variant="body2">{displayText}</Typography>
    </Box>
  );
}

NRSeverityLabel.propTypes = {
  severity: PropTypes.string,
  cvssScore: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default NRSeverityLabel;
